<div class="file-container">
  <!-- Required Documents Loop -->
  @for (item of documentTypesRequired; track item) {
  @if (getFiles(item).length > 0) {
  <!-- Files attached for this required type -->
  @for (file of getFiles(item); track file) {
  <ng-container *ngTemplateOutlet="fileCard; context: { $implicit: file }"></ng-container>
  }
  } @else if (typeAccess === 'owner') {
  <!-- Missing required file card -->
  <div class="file-card file-dending">
    <div class="file-icon">
      <mat-icon>upload_file</mat-icon>
    </div>
    <div class="file-info">
      <h4 class="file-title">{{ item }}</h4>
      <p class="file-name text-muted">Pendente de envio</p>
    </div>
    <div class="file-actions">
      <button mat-stroked-button color="primary" (click)="addAttachment(item)">
        <mat-icon>upload</mat-icon>
        <span>Anexar</span>
      </button>
    </div>
  </div>
  }
  }

  <!-- Extra Files Loop -->
  @for (file of getExtraFiles(); track file) {
  <ng-container *ngTemplateOutlet="fileCard; context: { $implicit: file }"></ng-container>
  }
</div>

<div class="footerButtons">
  <button mat-flat-button color="primary" (click)="addAttachment()">
    <mat-icon>add</mat-icon>
    <span>Anexar documento extra</span>
  </button>
</div>

<!-- Template for File Card -->
<ng-template #fileCard let-file>
  <div class="file-card">
    <div class="file-icon">
      <mat-icon>upload_file</mat-icon>
    </div>

    <div class="file-info">
      <h4 class="file-title">
        {{ file.documentType || 'Documento' }}
        @if(file.certifiedHubMedical){
        <img src="assets/icons/icon_certificado_concedido.svg" matTooltip="Certificado Hub Medical" width="20px"
          class="icon-cert">
        } @else {
        <img src="assets/icons/icon_certificado_ausente.svg" matTooltip="Não certificado" width="20px"
          class="icon-cert">
        }
      </h4>

      <p class="file-name">{{ file.fileName | truncate : 40 }}</p>

      <div class="file-meta">
        <p class="file-date">
          <span>Enviado: {{ file.uploadDate | date : "dd/MM/yyyy HH:mm" }}</span>
          @if(file.expirationDate){
          <span class="separator">•</span>
          <span [class.expired-text]="file.expired">
            Válido até: {{ file.expirationDate | date : "dd/MM/yyyy" }}
            {{ file.expired ? '(Vencido)' : '' }}
          </span>
          }
        </p>

        <span class="file-status badge" [class.badge-success]="file.sharePermitted" [class.badge-cancelled]="!file.sharePermitted">
          <mat-icon class="tiny-icon">{{ file.sharePermitted ? 'lock_open' : 'lock' }}</mat-icon>
          {{ file.sharePermitted ? "Permitido Compartilhar" : "Privado" }}
        </span>
      </div>
    </div>

    <div class="file-actions">
      <button mat-icon-button [matMenuTriggerFor]="fileMenu">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #fileMenu="matMenu">
        <button mat-menu-item (click)="download(file.fileName)">
          <mat-icon>download</mat-icon>
          <span>Baixar</span>
        </button>

        @if(typeAccess === 'owner'){
        <button mat-menu-item (click)="shareFile(file)">
          <mat-icon>{{ file.sharePermitted ? 'visibility_off' : 'visibility' }}</mat-icon>
          <span>{{ file.sharePermitted ? 'Bloquear Acesso' : 'Permitir Acesso' }}</span>
        </button>

        <button mat-menu-item class="delete-item" (click)="removeFile(file.id)">
          <mat-icon color="warn">delete</mat-icon>
          <span>Excluir</span>
        </button>
        }
      </mat-menu>
    </div>
  </div>
</ng-template>